export default "__VITE_ASSET__MH0TsiuL__"